var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.17173 7.53885L12.7542 3.3827L5.44123 8.66455L2.21808 8.0175C2.21794 8.01748 2.21781 8.01745 2.21767 8.01742C1.96738 7.96572 1.94762 7.62668 2.17156 7.53892L2.17173 7.53885Z",
    fill: "#878789",
    stroke: "#878789",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.75 9.48406L7.94102 11.4116L6.17947 13.1731L6.17947 13.1731L6.17812 13.1745C6.14334 13.2098 6.09884 13.234 6.05028 13.244C6.00172 13.2539 5.95129 13.2492 5.90541 13.2305C5.85952 13.2117 5.82024 13.1797 5.79257 13.1386C5.76493 13.0975 5.75012 13.0492 5.75 12.9997V9.48406Z",
    stroke: "#878789",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49909 8.93127L11.1178 13.875C11.1828 13.9325 11.2615 13.9721 11.3464 13.99C11.4313 14.0078 11.5193 14.0032 11.6019 13.9768C11.6845 13.9503 11.7588 13.9028 11.8175 13.8389C11.8761 13.7751 11.9172 13.697 11.9366 13.6125L14.2866 3.35002C14.3063 3.26164 14.3016 3.16956 14.2731 3.08363C14.2446 2.99769 14.1932 2.92112 14.1246 2.86208C14.0559 2.80305 13.9725 2.76377 13.8832 2.74843C13.794 2.7331 13.7023 2.74229 13.6178 2.77502L2.08034 7.30627C1.61784 7.48752 1.68034 8.16252 2.16784 8.26252L5.49909 8.93127Z",
    stroke: "#878789",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.93135L14.0063 2.7876",
    stroke: "#878789",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30625 11.3999L6.35625 13.3499C6.28668 13.4205 6.19768 13.4689 6.10056 13.4888C6.00344 13.5088 5.90259 13.4994 5.81081 13.4619C5.71904 13.4244 5.64049 13.3604 5.58515 13.2782C5.5298 13.1959 5.50017 13.099 5.5 12.9999V8.93115",
    stroke: "#878789",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelep);
export default __webpack_public_path__ + "static/media/telep.34e5a6b69500dd964b7ac61cb3a19692.svg";
export { ForwardRef as ReactComponent };